import { create } from 'zustand';
import { ChatMessage } from '../components/tour/regular/taiChat/MessageList';

export interface TAIConversation {
  id: number;
  tourId: number;
  sessionUuid: string;
  fingerprint: string;
  title: string | null;
  lastMessageAt: string | null;
  createdAt: string;
  updatedAt: string;
}

interface TAIChatState {
  currentConversationId: number | null;
  sessionId: string | null;
  messages: ChatMessage[];
  conversations: TAIConversation[];
  conversationsLoading: boolean;
}

interface TAIChatActions {
  setCurrentConversationId: (id: number | null) => void;
  setSessionId: (id: string) => void;
  setMessages: (messages: ChatMessage[]) => void;
  addMessage: (message: ChatMessage) => void;
  setConversations: (conversations: TAIConversation[]) => void;
  addConversation: (conversation: TAIConversation) => void;
  setConversationsLoading: (loading: boolean) => void;
  resetChat: () => void;
}

export const useTAIChatStore = create<TAIChatState & TAIChatActions>((set) => ({
  // State
  currentConversationId: null,
  sessionId: null,
  messages: [],
  conversations: [],
  conversationsLoading: false,

  // Actions
  setCurrentConversationId: (id) => set({ currentConversationId: id }),
  setSessionId: (id) => set({ sessionId: id }),
  setMessages: (messages) => set({ messages }),
  addMessage: (message) => set((state) => ({ messages: [...state.messages, message] })),
  setConversations: (conversations) => set({ conversations }),
  addConversation: (conversation) => set((state) => {
    const exists = state.conversations.some(c => c.id === conversation.id);
    if (exists) {
      return state;
    }
    const newConversations = [conversation, ...state.conversations];
    return { conversations: newConversations };
  }),
  setConversationsLoading: (loading) => set({ conversationsLoading: loading }),
  resetChat: () => set({ currentConversationId: null, sessionId: null, messages: [] }),
}));

